import React, { useState } from 'react'
import { Breadcrumb } from 'react-breadcrumbs'
import { Link } from 'react-router-dom'
import EditIcon from '@material-ui/icons/Edit'
import CityPage from './../../../../Containers/City/Page'
import { getCityLink } from 'Utils/Link'
import { ACTION_EDIT } from 'constants.js'
import StyledIconButton from '../../../../Components/Form/StyledIconButton'
import { styles } from './style'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import SubmitButton from 'Components/Form/SubmitButton'
import Roster from './Roster/index'
import List from './List/index'
import injectStyles from 'react-jss'

const Spy = props => {
  const { nav, cityId, cityName, classes, history, match } = props
  const [viewType, setViewType] = useState('list')

  return (
    <CityPage
      active={nav}
      cityId={cityId}
      history={history}
      match={match}
      cityName={cityName}
    >
      <Breadcrumb data={{ title: 'Spy', pathname: match.url }} />

      <Link to={getCityLink(cityId, ACTION_EDIT)} className="link-edit-main">
        <StyledIconButton>
          <EditIcon />
        </StyledIconButton>
      </Link>
      <div className={classes.spyWrapper}>
        <div className={classes.controls}>
          <ButtonGroup disableElevation color="primary">
            <SubmitButton
              value="List"
              variant={viewType === 'list' ? 'contained' : 'outlined'}
              onClick={() => setViewType('list')}
            />
            <SubmitButton
              value="Roster"
              variant={viewType === 'roster' ? 'contained' : 'outlined'}
              onClick={() => setViewType('roster')}
            />
          </ButtonGroup>
        </div>
        {viewType === 'roster' && <Roster {...props} />}
        {viewType === 'list' && <List {...props} />}
      </div>
    </CityPage>
  )
}

export default injectStyles(styles)(Spy)



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spy/index.js